import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import RightSection from "../teacherComponents/RightSectionTeacher/RightSection";
import NewsfeedSection from "../teacherComponents/Newsfeed/NewsfeedSection";
import Tabs from "../teacherComponents/TeacherTabs/Tabs";
import HeaderComponent from "../website/HeaderComponent";
import { getTutorData, getAttendance } from "../../actions/tutorFeedActions";
import HeaderForTeacher from "./HeaderForTeacher";
import $ from "jquery";
import { doLogin } from "../../actions/feedActions";
import TabsForRouting from "./TabsForRouting/TabsForRouting";
import { getToken } from "../../actions/emActions";

const SidebarForTeacher = (props) => {
  const [ClassesData, setClassesData] = useState([]);
  const [tutorInfo, settutorInfo] = useState("");
  const [programsData, setprogramsData] = useState([]);
  const [studentsData, setstudentsData] = useState([]);
  const [attendanceData, setattendanceData] = useState([]);
  const [attendanceInfo, setattendanceInfo] = useState("");
  const [isLoading, setisLoading] = useState(true);
  const [status, setstatus] = useState(6);

  if (props.tutorInfo !== tutorInfo || props.attendanceInfo !== attendanceInfo) {
    const { tutorInfo, attendanceInfo } = props;
    setprogramsData(tutorInfo.progs);
    setstudentsData(tutorInfo.teacher_students);
    setattendanceData(attendanceInfo.teacher_students);
    settutorInfo(tutorInfo);
    setattendanceInfo(attendanceInfo);
  }

  useEffect(() => {
    console.log("Location", window.location);
    var email = localStorage.getItem("userEmail");
    var password = localStorage.getItem("userPassword");
    var userType = JSON.parse(localStorage.getItem("loginUserInfo"));
    props.doLogin(email, password, userType?.user_type);

    var tutorData = JSON.parse(localStorage.getItem("loginData"));

    if (tutorData != null) {
      // if (window.location.href.includes("TeacherDashboard")) {
      getToken(tutorData.user.user_id).then((res) => {
        localStorage.setItem("loginToken", res.data.accessToken);
        setstatus(res?.data?.recruitment?.status);
      });
      // }
      window.smartlook("identify", tutorData.user.id, {
        name: tutorData.user.user_name,
        email: tutorData.user.user_email,
      });
      props
        .getAttendance(tutorData.user.id, tutorData.user.client_id)
        .then((res) => {
          setattendanceData(res.data.teacher_students);
          setisLoading(false);
        })
        .catch((err) => {
          setisLoading(false);
        });
      props
        .getTutorData(tutorData)
        .then((res) => {})
        .catch((err) => {});
    }
    setClassesData([
      {
        id: "one",
        program: "English Tution - Grade 5",
        data: "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
        avatarData: [
          {
            studentName: "Maheen Mushtaq",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
            value1: Math.floor(Math.random() * 100),
            value2: Math.floor(Math.random() * 100),
            value3: Math.floor(Math.random() * 100),
            attendanceStatus: "Absent",
            isChecked: false,
          },
          {
            studentName: "Shahreyar Ghazanfar",
            imagePath:
              "https://i.picsum.photos/id/1011/5472/3648.jpg?hmac=Koo9845x2akkVzVFX3xxAc9BCkeGYA9VRVfLE4f0Zzk",
            online: false,
            value1: Math.floor(Math.random() * 100),
            value2: Math.floor(Math.random() * 100),
            value3: Math.floor(Math.random() * 100),
            attendanceStatus: "Present",
            isChecked: true,
          },
          {
            studentName: "Sami Ali Khan",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
            value1: Math.floor(Math.random() * 100),
            value2: Math.floor(Math.random() * 100),
            value3: Math.floor(Math.random() * 100),
            attendanceStatus: "Absent",
            isChecked: false,
          },
          {
            studentName: "Saqib",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: false,
            value1: Math.floor(Math.random() * 100),
            value2: Math.floor(Math.random() * 100),
            value3: Math.floor(Math.random() * 100),
            attendanceStatus: "Absent",
            isChecked: false,
          },
          {
            studentName: "Riffat",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
            value1: Math.floor(Math.random() * 100),
            value2: Math.floor(Math.random() * 100),
            value3: Math.floor(Math.random() * 100),
            attendanceStatus: "Absent",
            isChecked: false,
          },
          {
            studentName: "Malik",
            imagePath:
              "https://i.picsum.photos/id/237/200/300.jpg?hmac=TmmQSbShHz9CdQm0NkEjx1Dyh_Y984R9LpNrpvH2D_U",
            online: true,
            value1: Math.floor(Math.random() * 100),
            value2: Math.floor(Math.random() * 100),
            value3: Math.floor(Math.random() * 100),
            attendanceStatus: "Absent",
            isChecked: false,
          },
        ],
      },
      {
        id: "two",
        program: "Math Tution - Grade 5",
        data: "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
        avatarData: [
          {
            studentName: "Hamza",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
          },
          {
            studentName: "Faheem",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
          },
          {
            studentName: "Afzal",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
          },
        ],
      },
      {
        id: "three",
        program: "Math Tution - Grade 7",
        data: "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
        avatarData: [
          {
            studentName: "Hamza",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
          },
          {
            studentName: "Faheem",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
          },
          {
            studentName: "Afzal",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
          },
        ],
      },
      {
        id: "four",
        program: "English Tution - Grade 7",
        data: "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
        avatarData: [
          {
            studentName: "Hamza",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
            value1: 10,
            value2: 25,
            value3: 55,
          },
          {
            studentName: "Faheem",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
            value1: 10,
            value2: 25,
            value3: 55,
          },
          {
            studentName: "Afzal",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
            value1: 10,
            value2: 25,
            value3: 55,
          },
        ],
      },
    ]);
    // fetch('/posts')
    //   .then((res) => {
    //     debugger;
    //     console.log("Response", res.json())
    //   })
    //   .catch((err) => {
    //     debugger;
    //     console.log(err);
    //     return err;
    //   })
  }, []);
  console.log("PROGRAMS", programsData);
  const changeValueonHover = () => {
    console.log("...");
    setClassesData([
      {
        id: "one",
        program: "English Tution - Grade 5",
        data: "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
        avatarData: [
          {
            studentName: "Maheen Mushtaq",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
            value1: Math.floor(Math.random() * 100),
            value2: Math.floor(Math.random() * 100),
            value3: Math.floor(Math.random() * 100),
          },
          {
            studentName: "Shahreyar Ghazanfar",
            imagePath:
              "https://i.picsum.photos/id/1011/5472/3648.jpg?hmac=Koo9845x2akkVzVFX3xxAc9BCkeGYA9VRVfLE4f0Zzk",
            online: false,
            value1: Math.floor(Math.random() * 100),
            value2: Math.floor(Math.random() * 100),
            value3: Math.floor(Math.random() * 100),
          },
          {
            studentName: "Sami Ali Khan",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
            value1: Math.floor(Math.random() * 100),
            value2: Math.floor(Math.random() * 100),
            value3: Math.floor(Math.random() * 100),
          },
          {
            studentName: "Saqib",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: false,
            value1: Math.floor(Math.random() * 100),
            value2: Math.floor(Math.random() * 100),
            value3: Math.floor(Math.random() * 100),
          },
          {
            studentName: "Riffat",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
            value1: Math.floor(Math.random() * 100),
            value2: Math.floor(Math.random() * 100),
            value3: Math.floor(Math.random() * 100),
          },
          {
            studentName: "Malik",
            imagePath:
              "https://i.picsum.photos/id/237/200/300.jpg?hmac=TmmQSbShHz9CdQm0NkEjx1Dyh_Y984R9LpNrpvH2D_U",
            online: true,
            value1: Math.floor(Math.random() * 100),
            value2: Math.floor(Math.random() * 100),
            value3: Math.floor(Math.random() * 100),
          },
        ],
      },
      {
        id: "two",
        program: "Math Tution - Grade 5",
        data: "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
        avatarData: [
          {
            studentName: "Hamza",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
          },
          {
            studentName: "Faheem",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
          },
          {
            studentName: "Afzal",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
          },
        ],
      },
      {
        id: "three",
        program: "Math Tution - Grade 7",
        data: "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
        avatarData: [
          {
            studentName: "Hamza",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
          },
          {
            studentName: "Faheem",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
          },
          {
            studentName: "Afzal",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
          },
        ],
      },
      {
        id: "four",
        program: "English Tution - Grade 7",
        data: "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
        avatarData: [
          {
            studentName: "Hamza",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
            value1: 10,
            value2: 25,
            value3: 55,
          },
          {
            studentName: "Faheem",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
            value1: 10,
            value2: 25,
            value3: 55,
          },
          {
            studentName: "Afzal",
            imagePath:
              "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
            online: true,
            value1: 10,
            value2: 25,
            value3: 55,
          },
        ],
      },
    ]);
  };
  console.log("SMART", window);
  return (
    <div className="FeedComponent FeedComponentForTeacher">
      <HeaderForTeacher
      // whiteLabel={this.state.isWhiteLabel}
      // headerData={{ studentName: this.state.teacherInfo.user_name }}
      />
      <div style={{ padding: "2vh 0" }}>
        <div className="container-fluid">
          <div className="row">
            {programsData && programsData.length > 0 && (
              <div className="col-md-3">
                <RightSection
                  programsData={programsData}
                  studentsData={studentsData}
                  attendanceData={attendanceData}
                  isLoading={isLoading}
                />
              </div>
            )}
            {/* <div className="col-md-6">
              <NewsfeedSection />
              <Tabs onHoverChange={changeValueonHover} />
            </div>
            <div className="col-md-3 ">
              <div class="card border shadow-lg p-3 rounded">
                <div class="card-header"></div>
                <div class="card-body">
                  <h5 class="card-title"></h5>
                  <p class="card-text">
                    Chat Messaging supporting text below as a natural lead-in to
                    additional content.
                </p>
                </div>
              </div>
            </div> */}
            {programsData && programsData.length === 0 ? (
              <div className="col-md-12">
                <TabsForRouting status={status} />
                {props.children}
              </div>
            ) : (
              <div className="col-md-9">
                <TabsForRouting status={status} />
                {props.children}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    tutorInfo: state.feedRed.loginSuccessNormal,
    attendanceInfo: state.feedTutorRed.attendanceData,
  };
}
export default connect(mapStateToProps, { getTutorData, getAttendance, doLogin })(
  SidebarForTeacher
);
